<template>
  <div class="userLeftAll">
    <div class="userLeft_time">
      <p>{{ userInfo.flowStatusName }}</p>
    </div>
    <div class="userLeft_expert">{{ userInfo.levelName }}</div>
    <img
      style="
        width: 150px;
        height: 150px;
        margin-top: 20px;
        object-fit: scale-down;
      "
      :src="userInfo.photo ? userInfo.photo : normalImg"
    />

    <p class="userLeftAll_p">{{ userInfo.realName }}</p>
    <span class="userLeftAll_span" v-show="userInfo.certNumber"
      >ID：{{ userInfo.certNumber }}</span
    >
    <el-button type="primary" v-if="showPay" @click="openPay"
      >立即续费</el-button
    >
    <div class="userLeftSelect">
      <p
        v-for="(item, index) in navList"
        :class="[selectIndex == index ? 'useActive' : '']"
        :key="index"
        @click="changeSelect(item, index)"
      >
        {{ item.name }}
      </p>
      <p
        v-if="userInfo.level == 4 || userInfo.level == 5"
        :class="[selectIndex == 7 ? 'useActive' : '']"
        @click="iframeView"
      >
        {{ iframeList[0].name }}
      </p>
    </div>
    <uploadPay ref="uploadpay" @refresh="getPayStatus" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getExpertIfame, isPay, getVipUser } from "@/api/moudles/user";
import uploadPay from "./uploadPay.vue";
export default {
  data() {
    return {
      showPay: false,
      normalImg: require("../../../assets/img/userIndex/head.png"),
      selectIndex: 0,
      payCode: "",
      uploadpay: null,
      navList: [
        {
          name: "个人信息",
          path: "userinfo",
          type: "router",
        },
        {
          name: "缴费管理",
          path: "paymanage",
          type: "router",
        },
        {
          name: "我的留言",
          path: "leave",
          type: "router",
        },
        {
          name: "信息变更",
          path: "infoChange",
          type: "router",
        },
        {
          name: "会员证书",
          path: "certificate",
          type: "router",
        },
        // {
        // 	name: '修改手机号',
        // 	path: 'changephone'
        // },

        {
          name: "修改密码",
          path: "changepassword",
          type: "router",
        },
        {
          name: "专业证书",
          path: "professionalCert",
          type: "link",
        },
        {
          name: "培训证书",
          path: "trainingCert",
          type: "link",
        },
        // {
        //   name: "积分管理",
        //   path: "pointManagement",
        //   type: "router",
        // },
      ],
      iframeList: [
        {
          name: "专家评分",
          path: "http://",
          type: "iframe",
        },
      ],
      iframeUrl: "",
    };
  },
  components: {
    uploadPay,
  },
  watch: {
    $route: function () {
      if (this.selectIndex != this.$route.meta.uid) {
        this.selectIndex = this.$route.meta.uid;
      }
    },
  },
  created() {
    if (this.selectIndex != this.$route.meta.uid) {
      this.selectIndex = this.$route.meta.uid;
    }
    getExpertIfame({
      data: {},
      success: (res) => {
        if (res.data && res.data.menuUrl) {
          this.iframeUrl = res.data.menuUrl;
        }
      },
    });
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),
  mounted() {
    getVipUser({
      success: (res) => {
        console.log("vipUser", res);
        if (res.data && res.data.memberCode) {
          this.getPayStatus(res.data.memberCode);

          this.navList = [
            {
              name: "个人信息",
              path: "userinfo",
              type: "router",
            },
            {
              name: "缴费管理",
              path: "paymanage",
              type: "router",
            },
            {
              name: "我的留言",
              path: "leave",
              type: "router",
            },
            {
              name: "信息变更",
              path: "infoChange",
              type: "router",
            },
            {
              name: "会员证书",
              path: "certificate",
              type: "router",
            },
            {
              name: "修改密码",
              path: "changepassword",
              type: "router",
            },
            {
              name: "专业证书",
              path: "professionalCert",
              type: "link",
            },
            {
              name: "培训证书",
              path: "trainingCert",
              type: "link",
            },
            {
              name: "学习记录",
              path: "studyRecord",
              type: "router",
            },
          ];
        } else {
          setTimeout(() => {
            this.getPayStatus(this.userInfo.memberCode);
          }, 1000);
        }
      },
    });
  },
  methods: {
    openPay() {
      this.$refs["uploadpay"].openDialog(this.payCode);
    },
    async getPayStatus(memberCode) {
      await isPay({
        data: {
          memberCode: memberCode,
        },
        success: (res) => {
          if (res.data && res.data.payStatus == 1) {
            this.showPay = true;
            this.payCode = res.data.code;
          }
        },
      });
    },
    // iframe点击
    iframeView() {
      this.selectIndex = 7;
      this.$router.push({
        name: "userIframe",
        params: {
          url: this.iframeUrl,
          code: "",
        },
      });
    },
    changeSelect(item, index) {
      console.log("item", item);
      console.log("index", index);
      if (
        (item.name == "专业证书" || item.name == "培训证书") &&
        this.userInfo.flowStatusName.indexOf("会员到期时间") == -1
      ) {
        this.$message.warning("您好，您的缴费审核还未通过，请耐心等待！");
        return;
      }
      if (item.type === "link") {
        if (localStorage.dynamicConfig) {
          this.selectIndex = index;
          this.$router.push({
            path: "/" + item.path,
            query: {
              name: this.userInfo.realName.trim(),
              phone: this.userInfo.cellphone,
              type: item.name,
            },
          });
        }
        return;
      }
      if (this.userInfo.flowStatus === 1 || this.userInfo.flowStatus === 2) {
        //1\ 基本信息有审核中、审核通过
        //2\ 证书信息有审核中、审核通过
        if (index == 3) {
          // 会员证书
          this.$message.warning(
            "您好，您的材料正在审核，审核结束后可查看电子证书，请耐心等待！"
          );
        } else if (index == 1) {
          // 缴费管理
          this.$message.warning(
            "您好，请提交基本信息，如已提交等待材料审核结果后重试！"
          );
        } else {
          this.selectIndex = index;
          this.$router.push("/" + item.path);
        }
      } else {
        // 3\" 控制显示缴费
        if (this.userInfo.status != 2) {
          // 3是基本信息和证书信息都有审核中、审核通过
          if (index == 3) {
            // 会员证书
            this.$message.warning(
              "您好，您的材料正在审核，审核结束后可查看电子证书，请耐心等待！"
            );
          } else {
            this.selectIndex = index;
            this.$router.push("/" + item.path);
          }
        } else {
          this.selectIndex = index;
          this.$router.push("/" + item.path);
        }
      }
    },
  },
};
</script>

<style scoped>
.userLeftAll {
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: #fff;
  padding-bottom: 40px;
  position: relative;
}

.userLeft_expert {
  position: absolute;
  right: 15px;
  top: 45px;
  min-width: 40px;
  padding: 3px;
  border: 1px solid #bc141c;
  color: #bc141c;
  border-radius: 5px;
  text-align: center;
}

.userLeftAll_p {
  font-size: 20px;
  font-weight: 600;
  margin-top: 20px;
}

.userLeftAll_span {
  margin-top: 10px;
  font-size: 16px;
  color: #a5a5a5;
}

.userLeft_time {
  height: 30px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #c19b61;
}

.userLeftSelect {
  margin-top: 50px;
}

.userLeftSelect p {
  cursor: pointer;
  width: 100%;
  text-align: center;
  display: inline-block;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
}

.useActive {
  border-left: 4px solid #bc141c;
  background-color: #f6e1e0;
  color: #bc141c;
}
</style>
